import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import formatDate from '@afosto/utils/date/formatDate';
import translations from './translations';
import styled from 'styled-components';

const InvoiceStatusChip = styled(Chip)`
  && {
    margin-left: ${props => props.theme.spacing(1)}px;
  }
`;

const InvoiceInfo = ({ invoice }) => {
  const intl = useIntl();
  const {
    reference,
    products = [],
    is_paid: isPaid,
    is_pending: isPending,
    invoiced_at: invoicedAt,
  } = invoice;
  const productNames = [...new Set(products.map(({ name }) => name))];

  const stateSettings = {
    label: 'concept',
    color: 'default',
  };

  if (isPending) {
    stateSettings.label = 'outstanding';
    stateSettings.color = 'secondary';
  }
  if (isPaid) {
    stateSettings.label = 'paid';
    stateSettings.color = 'default';
  }

  return (
    <>
      <Box display="flex" alignItems="baseline">
        <Typography variant="body1">{reference}</Typography>
        <InvoiceStatusChip
          size="small"
          label={intl.formatMessage(translations.formatters.paymentStatus[stateSettings.label])}
          color={stateSettings.color}
          variant="outlined"
        />
      </Box>
      <Typography variant="caption" color="textSecondary" component="div">
        {productNames.join(', ')}
      </Typography>
      <Typography variant="caption" color="textSecondary">
        {formatDate(new Date(invoicedAt))}
      </Typography>
    </>
  );
};

InvoiceInfo.propTypes = {
  invoice: PropTypes.object.isRequired,
};

export default InvoiceInfo;
